import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ICartItemForUpdate } from "@faire/retailer-visitor-shared/stores/domain/CartStore/consts";
import { AddToCartVariants } from "@faire/retailer-visitor-shared/stores/domain/CartStore/triggerAddToCartEvent";
import { AddToCartAnimation } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/DisplayCollectionPromo/AddToBagAnimation";
import { useCollectionDisplayPromo } from "@faire/retailer-visitor-shared/views/product-based-collection/useCollectionDisplayPromo";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackCoreCollectionsAddDisplayClick } from "@faire/web-api--source/events/coreCollections/click/addDisplay";
import { observer } from "mobx-react";
import { useCallback } from "react";
import * as React from "react";
import styled from "styled-components";
var DisplayStickyActionBannerBase = function(param) {
    var collection = param.collection, updateItems = param.updateItems;
    var showCollectionDisplayPromoTrackingBanner = useCollectionDisplayPromo(collection).showCollectionDisplayPromoTrackingBanner;
    var isSSR = useIsSSR();
    var _React_useState = _sliced_to_array(React.useState(false), 2), showToastsBanner = _React_useState[0], setShowToastBanner = _React_useState[1];
    var onAnimationComplete = useCallback(function() {
        setShowToastBanner(false);
    }, []);
    var addDisplayProductToCart = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _collection_active_display_promo_free_display_product_tile, _collection_active_display_promo_free_display_product, _collection_active_display_promo, product, _collection_active_display_promo_free_display_product_tile1, _collection_active_display_promo_free_display_product1, _collection_active_display_promo1, _collection_token, _product_token;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        product = (_collection_active_display_promo = collection.active_display_promo) === null || _collection_active_display_promo === void 0 ? void 0 : (_collection_active_display_promo_free_display_product = _collection_active_display_promo.free_display_product) === null || _collection_active_display_promo_free_display_product === void 0 ? void 0 : (_collection_active_display_promo_free_display_product_tile = _collection_active_display_promo_free_display_product.tile) === null || _collection_active_display_promo_free_display_product_tile === void 0 ? void 0 : _collection_active_display_promo_free_display_product_tile.product;
                        if (!product) return [
                            3,
                            2
                        ];
                        trackCoreCollectionsAddDisplayClick((_collection_token = collection.token) !== null && _collection_token !== void 0 ? _collection_token : "", (_product_token = product.token) !== null && _product_token !== void 0 ? _product_token : "");
                        return [
                            4,
                            updateItems([
                                ICartItemForUpdate.build({
                                    token: product.token,
                                    product_token: product.token,
                                    brand_token: collection.brand_token,
                                    product_option_token: (_collection_active_display_promo1 = collection.active_display_promo) === null || _collection_active_display_promo1 === void 0 ? void 0 : (_collection_active_display_promo_free_display_product1 = _collection_active_display_promo1.free_display_product) === null || _collection_active_display_promo_free_display_product1 === void 0 ? void 0 : (_collection_active_display_promo_free_display_product_tile1 = _collection_active_display_promo_free_display_product1.tile) === null || _collection_active_display_promo_free_display_product_tile1 === void 0 ? void 0 : _collection_active_display_promo_free_display_product_tile1.selected_product_option_token,
                                    quantity: 1
                                })
                            ], {
                                upltParams: {
                                    event: "add-to-cart",
                                    startTime: Date.now(),
                                    variant: AddToCartVariants.FREE_DISPLAY
                                }
                            }).then(function() {
                                setShowToastBanner(true);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function addDisplayProductToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    if (showCollectionDisplayPromoTrackingBanner) {
        var _collection_active_display_promo_free_display_product_metadata_image, _collection_active_display_promo_free_display_product_metadata, _collection_active_display_promo_free_display_product, _collection_active_display_promo;
        return /*#__PURE__*/ _jsxs(StickyActionBanner, {
            children: [
                /*#__PURE__*/ _jsx(ProductImage, {
                    src: optimizeImageUrl({
                        url: (_collection_active_display_promo = collection.active_display_promo) === null || _collection_active_display_promo === void 0 ? void 0 : (_collection_active_display_promo_free_display_product = _collection_active_display_promo.free_display_product) === null || _collection_active_display_promo_free_display_product === void 0 ? void 0 : (_collection_active_display_promo_free_display_product_metadata = _collection_active_display_promo_free_display_product.metadata) === null || _collection_active_display_promo_free_display_product_metadata === void 0 ? void 0 : (_collection_active_display_promo_free_display_product_metadata_image = _collection_active_display_promo_free_display_product_metadata.image) === null || _collection_active_display_promo_free_display_product_metadata_image === void 0 ? void 0 : _collection_active_display_promo_free_display_product_metadata_image.url
                    }, isSSR, {
                        width: DISPLAY_PRODUCT_IMAGE_DIMENSION,
                        height: DISPLAY_PRODUCT_IMAGE_DIMENSION
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: 12
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    justify: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraphSansMedium",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "J1IIlk",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "You unlocked a free display!"
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "1x"
                        }),
                        /*#__PURE__*/ _jsx(StyledAddToCartButton, {
                            onClick: addDisplayProductToCart,
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "oVr3/a",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Add to bag"
                                    }
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
    if (showToastsBanner) {
        var _collection_active_display_promo_free_display_product_metadata_image1, _collection_active_display_promo_free_display_product_metadata1, _collection_active_display_promo_free_display_product1, _collection_active_display_promo1;
        return /*#__PURE__*/ _jsx(AddToCartAnimation, {
            onAnimationComplete: onAnimationComplete,
            displayProductImageUrl: (_collection_active_display_promo1 = collection.active_display_promo) === null || _collection_active_display_promo1 === void 0 ? void 0 : (_collection_active_display_promo_free_display_product1 = _collection_active_display_promo1.free_display_product) === null || _collection_active_display_promo_free_display_product1 === void 0 ? void 0 : (_collection_active_display_promo_free_display_product_metadata1 = _collection_active_display_promo_free_display_product1.metadata) === null || _collection_active_display_promo_free_display_product_metadata1 === void 0 ? void 0 : (_collection_active_display_promo_free_display_product_metadata_image1 = _collection_active_display_promo_free_display_product_metadata1.image) === null || _collection_active_display_promo_free_display_product_metadata_image1 === void 0 ? void 0 : _collection_active_display_promo_free_display_product_metadata_image1.url
        });
    }
    return null;
};
export var DisplayStickyActionBanner = observer(DisplayStickyActionBannerBase);
export var DISPLAY_PRODUCT_IMAGE_DIMENSION = 72;
var ProductImage = styled.img.withConfig({
    componentId: "sc-baf79478-0"
})([
    "width:",
    "px;height:",
    "px;"
], DISPLAY_PRODUCT_IMAGE_DIMENSION, DISPLAY_PRODUCT_IMAGE_DIMENSION);
var StickyActionBanner = styled(Row).withConfig({
    componentId: "sc-baf79478-1"
})([
    "background-color:",
    ";position:sticky;z-index:5;bottom:",
    ";right:",
    ";width:360px;max-width:calc(100% - ",
    ");padding:",
    ";border:1px solid ",
    ";margin-left:auto;"
], Core.surface.inverse, getSpacing(12), getSpacing(12), getSpacing("3x"), getSpacing(12), Core.border.muted);
var StyledAddToCartButton = styled(Button).withConfig({
    componentId: "sc-baf79478-2"
})([
    "height:34px;width:fit-content;"
]);
